/**************************************************************************************************/
/*   File: /src/app/shared/components/file-type-selector/file.type.selector.ts                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, EventEmitter, Input, Output } from '@angular/core';

import * as fromEnums from '../../enums';
import * as fromModels from '../../models';

/**
 * The geo file type selector
 */
@Component({
    selector: 'nwpl-frnt-file-type-selector',
    templateUrl: './file.type.selector.html',
    styleUrls: ['./file.type.selector.scss']
})
export class FileTypeSelectorComponent {

    /**
     * The gile types array
     */
    @Input() types: fromModels.GeoFileType[];
    /**
     * The selected file type
     */
    @Input() selectedType: fromEnums.SpatialDataTypeEnum;
    /**
     * The selected event emitter
     */
    @Output() selected: EventEmitter<fromEnums.SpatialDataTypeEnum> = new EventEmitter<fromEnums.SpatialDataTypeEnum>();
    /**
     * The is validating
     */
    @Input() isValidating: boolean;
    /**
     * The is validated flag
     */
    @Input() isValidated: boolean;
    /**
     * The view type 'button' | 'select';
     */
    @Input() viewType: 'button' | 'select';
      /**
     * The show strategy
     */
    @Input() showStrategy: 'disable' | 'hide' = 'disable';
    /**
     * The disabled condition
     */
    @Input() disabled: boolean;

    @Input() preselect: boolean = false;
    
    @Input() isPageDownload: boolean = false;

    /**
     * The constructor
     */
    constructor() { }

    /**
     * Select geo type
     * @param number the id of file selected
     */
    selectGeoType(type: fromEnums.SpatialDataTypeEnum) {
        this.selected.emit(type as fromEnums.SpatialDataTypeEnum);
    }

    /**
     * The selection throug select
     */
    selectGeoTypeSelect(type: fromEnums.SpatialDataTypeEnum) {
        this.selected.emit(type as fromEnums.SpatialDataTypeEnum);
    }
}
